const crudServiceMixin = {
  methods: {
    post(url, model) {
      return this.$axios.post(url, model);
    },
    delete(url, id) {
      return this.$axios.delete(`${url}/${id}`);
    },
    get(url, params) {
      return this.$axios.get(url, params);
    },
    getById(url, id) {
      return this.$axios.get(`${url}/${id}`);
    },
    put(url, model) {
      return this.$axios.put(url, model);
    },
  },
};
export default crudServiceMixin;
